import { parseISO, toDate } from 'date-fns';
import React from 'react';
import { useSelector } from 'react-redux';

import useTimezone from '@swf/core/hooks/useTimezone';
import { select } from '@swf/core/store';

export type CustomDate = number | string;

export interface Props extends Intl.DateTimeFormatOptions {
  showTimeZone?: boolean;
  date: CustomDate;
}

const FormattedTimeZone: React.FC<Props> = ({ showTimeZone, date, ...rest }) => {
  const { timeZoneName } = useTimezone();
  const locale = useSelector(select.locale.getIntlLocale);

  const dateTimeFormatOptions = {
    ...rest,
    timeZone: timeZoneName
  };

  const parsedDate = typeof date === 'string' ? parseISO(date) : toDate(date);
  const formattedDate = parsedDate.toLocaleString(locale, dateTimeFormatOptions);

  return (
    <span>
      {formattedDate}
      {showTimeZone && ` ${timeZoneName.replace('_', ' ')}`}
    </span>
  );
};

export default FormattedTimeZone;
